import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkingTimeModalService {
  private _showWorkingTimeModalSubject$ = new Subject();

  get showWorkingTimeModal$(): Observable<unknown> {
    return this._showWorkingTimeModalSubject$.asObservable();
  }

  open(): void {
    this._showWorkingTimeModalSubject$.next(null);
  }
}
